<div toastContainer>
  <!-- En este espacio aparecen todas las notificaciones -->
</div>

<div class="main-container">
  <div id="header-container" class="header-container">
    <app-appbar></app-appbar>
  </div>
  <div id="body-container" class="body-container">
    <div class="menu">
      <img src="/assets/images/menu/menu.png" class="menu" style="margin-top: 0px; width: 24px; height: 24px;"
        title="Menú" (click)="tongleMenu()" />
    </div>
    <div id="menu-container" class="menu-container">
      <app-menu></app-menu>
    </div>
    <div id="center-container" class="center-container">
      <jqxSplitter #rightSplitter [theme]="environment.tema" [width]="'100%'" [height]="'100%'"
        [orientation]="'vertical'" [panels]="[{ size: '65%', collapsible: false }, { size: '35%'}]"
        (onResize)="onResizeSpliter($event)" (onExpanded)="changeSplitterState(true, 'rightSplitter')" (onCollapsed)="changeSplitterState(false, 'rightSplitter')">
        <div>
          <jqxSplitter #downSplitter [theme]="environment.tema" [width]="'100%'" [height]="'100%'"
            [orientation]="'horizontal'" [panels]="[{ size: '60%', collapsible: false }, { size: '40%'}]"
            (onResize)="onResizeSpliter($event)" (onExpanded)="changeSplitterState(true, 'downSplitter')" (onCollapsed)="changeSplitterState(false, 'downSplitter')">
            <div class="map-container" id="map-container">

              <div id="superiorTabs" class="tab">
                <button id="tabMap0" class="tablinks" style="height: 22px; vertical-align: middle;"
                  (click)="onClickTabMap($event, 0)">
                  <span id="mapaPrincipal" style="float: left;"><img width="16" height="16" src={{maps[0].icon}}>
                    {{translate('Mapa')}}
                  </span>
                </button>

                <ng-container *ngFor="let item of tabsInfo; let i = index;">
                  <ng-container *ngIf="item.visible">
                    <div class="button-container">
                      <button title="{{translate(item.label)}}" id="{{item.id}}"
                        [ngClass]="{'button-selected': item.activated}" (click)="onClickTabMap(item)">
                        <span class="button-label">
                          {{ translate(item.label) }}
                        </span>
                        <button (click)="destroyComponent(item); $event.stopPropagation();"> <i class="fa fa-times"
                            aria-hidden="true"></i></button>
                      </button>
                    </div>
                  </ng-container>
                </ng-container>

              </div>

              <div class="tabcontent" id="map0">
                <movisat-map [provider]="mapProvider" [cartoType]="cartoType" [lang]="lang"
                  [texts]="langService.getCurrentTexts()" [searchBounds]="searchBounds" [searchCountry]="searchCountry"
                  [zoom]="zoom" [center]="center" [noSearch]="false" (mapReady)="onMapReady($event)"
                  (mapClick)="onMapClick($event)" (boundsChange)="onBoundsChange($event)"
                  (zoomChange)="onZoomChange($event)" (markerClick)="onMarkerClick($event)"
                  (markerDragEnd)="onMarkerDragEnd($event)" (polylineClick)="onPolylineClick($event)"
                  (polygonClick)="onPolygonClick($event)" (polygonDragEnd)="onPolygonDragEnd($event)"
                  (circleClick)="onCircleClick($event)" (mapMouseMove)="onMapMouseMove($event)"
                  (circleDragEnd)="onCircleDragEnd($event)" (circleRadiusChanged)="onCircleRadiusChanged($event)">
                </movisat-map>
              </div>
              <app-map-toolbar></app-map-toolbar>
              <!-- Contenedores de contenido de pestañas -->
              <ng-template #dynamicContainer></ng-template>
            </div>

            <div #gestionContainer id="area-gestion-container" class="area-gestion-container">
              <jqxRibbon #tabGestion class="jqx-widget-content-material" [theme]="environment.tema" [width]="'100%'" [height]="'100%'" [position]="'top'" (onChange)="onRibbonChange($event.args.selectedIndex)">
                <ul>
                  <li>
                    <img src="assets/images/movilidad.png" />
                    {{translate('Flota')}}: {{recordMovilesCountTotal() }} {{ ' (' +
                    recordCountMovilesUpdate() + ')' }}
                    <input type="button" class="button-close-bottom" value="X"
                      (click)="closeTab('MOVILES'); $event.stopPropagation()" />
                  </li>
                  <li>
                    <img src="assets/images/elements.png" />
                    {{translate('Elementos')}}: {{recordCountElementsTotal()}} {{ ' (' +
                    recordCountElementsUpdate() + ')' }}
                    <input type="button" class="button-close-bottom" value="X"
                      (click)="closeTab('ELEMENTOS'); $event.stopPropagation()" />
                  </li>
                  <li>
                    <img src="assets/images/pu.png" />
                    {{translate('Puntos_ubicacion')}}: {{recordCountPuTotal()}} {{ ' (' +
                    recordCountPuUpdate() + ')' }}
                    <input type="button" class="button-close-bottom" value="X"
                      (click)="closeTab('PUNTOS_UBICACION'); $event.stopPropagation()" />
                  </li>
                  <li>
                    <img src="assets/images/personas.png" />
                    {{translate('Ciudadanos')}}: {{getNumCiudadanos()}}
                    <input type="button" class="button-close-bottom" value="X"
                      (click)="closeTab('GESTION_CIUDADANOS'); $event.stopPropagation()" />
                  </li>
                  <li>
                    <img src="assets/images/ia.png" />
                    {{translate('Elementos')}}-IA
                    <input type="button" style="margin-left: 6px;" class="button-close-bottom" value="X" style="margin-left: 6px;"
                      (click)="closeTab('IA_ESTUDIO_ACTUAL'); $event.stopPropagation()" />
                  </li>
                </ul>

                <div>
                  <div>
                    <app-moviles></app-moviles>
                  </div>
                  <div>
                    <app-elements></app-elements>
                  </div>
                  <div>
                    <app-pu></app-pu>
                  </div>
                  <div>
                    <app-ciudadanos></app-ciudadanos>
                  </div>
                  <div>
                    <div #gridElemIaContainer>
                      <!-- Contenedor para el grid de elementos IA -->
                    </div>
                  </div>
                </div>
              </jqxRibbon>
            </div>
          </jqxSplitter>
        </div>
        <div id="right-container">
          <div #rightContainer class="right-container">
            <!-- Contenedor de la derecha multiproposito -->
            <jqxRibbon style="overflow: hidden;" [theme]="environment.tema" [width]="'100%'"
              [height]="'100%'" [position]="'top'">
              <ul style="width: 100%; text-align: left;">
                <li #divTab id="tabItinerary" [hidden]="!formItineraryVisible() || isEcoEvolution"
                  style="height: 28px; vertical-align: middle;" (click)="onClickTab(_this.ITINERARIOS_TAB)">
                  <span style="float: left;"><img width="20" height="20" src="assets/images/itinerary.png">
                    {{translate('Itinerarios')}}
                  </span>
                </li>
              </ul>
              <div>
                <div>
                  <!-- Contenedor para los itinerarios -->
                  <div [hidden]="!formItineraryVisible() || isEcoEvolution" id="itineraryInfo">
                  </div>
                </div>
              </div>
            </jqxRibbon>
          </div>
        </div>
      </jqxSplitter>
    </div>
  </div>
  <div id="footer-container" class="footer-container">
    <app-footer></app-footer>
  </div>
</div>
